// 3rd-party
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

// Services
import { getStorageItemLocal } from "../../services/storageServices";

// Asset components
import logoup from "../../assets/arrow-up.svg";
import logodown from "../../assets/arrow-down.svg";
import content from "../../assets/content.svg";
import category from "../../assets/category.svg";
import pdficon from "../../assets/pdf_icon.svg";
import publish from "../../assets/PublishIcon.svg";
import profile from "../../assets/profileIcon.svg";
import audit from "../../assets/auditandtrails.svg";

// Styles
import "./SidebarLayout.scss";

const SidebarLayout = () => {
  const [expanded, setExpanded] = useState<string | null>(null);
  const [expanded1, setExpanded1] = useState<string | null>(null);

  const [role, setRole] = useState<string>("");

  useEffect(() => {
    const storedRole = getStorageItemLocal("role");

    if (storedRole) setRole(JSON.parse(storedRole));
  }, []);

  const handleToggle = (section: string) => {
    setExpanded((prev) => (prev === section ? null : section));

    if (expanded === "Home" || expanded === "Category") setExpanded1(null);
  };
  const handleToggle1 = (section: string) => {
    setExpanded1(section);
  };

  return (
    <div className="sidebar open">
      <ul>
        {role === "System Admin" && (
          <li>
            <Link to="/master/home" style={{ textDecoration: "none" }}>
              <div onClick={() => handleToggle("Home")} className="parent-li">
                <Box
                  className={expanded === "Home" ? "active" : "notactive"}
                  sx={{ display: "flex", alignItems: "center", width: "100%" }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "5px" }}
                  >
                    <img src={publish} alt="Category" className="icons" />
                    <Typography className="headings">Publish</Typography>
                  </Box>
                </Box>
              </div>
            </Link>
          </li>
        )}

        {/* 2nd */}

        <li>
          <div onClick={() => handleToggle("Content")} className="parent-li">
            <Box
              className={expanded === "Content" ? "active" : "notactive"}
              sx={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <img src={content} alt="content" className="icons" />
                <Typography className="headings">Content (Edits)</Typography>
              </Box>
              <Box sx={{ marginLeft: "auto", marginRight: "10px" }}>
                {expanded === "Content" ? (
                  <img src={logoup} alt="up_arrow" className="app-logo" />
                ) : (
                  <img src={logodown} alt="down_arrow" className="app-logo" />
                )}
              </Box>
            </Box>
          </div>
          {expanded === "Content" && (
            <ul>
              <li>
                <Link to="/master/India" style={{ textDecoration: "none" }}>
                  <Box
                    className={
                      expanded1 === "Content1" ? "active1" : "notactive1"
                    }
                    onClick={() => handleToggle1("Content1")}
                  >
                    <Typography className="sub-headings ">India</Typography>
                  </Box>
                </Link>
              </li>
              <li>
                <Link
                  to="/master/Statelevel"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    className={
                      expanded1 === "Content2" ? "active1" : "notactive1"
                    }
                    onClick={() => handleToggle1("Content2")}
                  >
                    <Typography className="sub-headings ">States</Typography>
                  </Box>
                </Link>
              </li>

              <li>
                <Link to="/master/Highlight" style={{ textDecoration: "none" }}>
                  <Box
                    className={
                      expanded1 === "Content3" ? "active1" : "notactive1"
                    }
                    onClick={() => handleToggle1("Content3")}
                  >
                    <Typography className="sub-headings ">Highlight</Typography>
                  </Box>
                </Link>
              </li>
            </ul>
          )}
        </li>
        {/* 3rd */}

        <li>
          <Link to="/master/main" style={{ textDecoration: "none" }}>
            <div onClick={() => handleToggle("Category")} className="parent-li">
              <Box
                className={expanded === "Category" ? "active" : "notactive"}
                sx={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <img src={category} alt="Category" className="icons" />
                  <Typography className="headings">Category</Typography>
                </Box>
              </Box>
            </div>
          </Link>
        </li>

        {/* 4th */}
        <li>
          <div onClick={() => handleToggle("pdf")} className="parent-li">
            <Box
              className={expanded === "pdf" ? "active" : "notactive"}
              sx={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <img src={pdficon} alt="pdficon" className="icons" />
                <Typography className="headings">State Management</Typography>
              </Box>
              <Box sx={{ marginLeft: "auto", marginRight: "10px" }}>
                {expanded === "pdf" ? (
                  <img src={logoup} alt="up_arrow" className="app-logo" />
                ) : (
                  <img src={logodown} alt="down_arrow" className="app-logo" />
                )}
              </Box>
            </Box>
          </div>
          {/* </Link> */}
          {expanded === "pdf" && (
            <ul>
              {/* new changes */}
              <li>
                <Link
                  to="/master/Statesintro"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    className={
                      expanded1 === "IntroductiveVideo"
                        ? "active1"
                        : "notactive1"
                    }
                    onClick={() => handleToggle1("IntroductiveVideo")}
                  >
                    <Typography className="sub-headings ">
                      Introductive Video
                    </Typography>
                  </Box>
                </Link>
              </li>

              {/*  */}

              <li>
                <Link to="/master/StateData" style={{ textDecoration: "none" }}>
                  <Box
                    className={expanded1 === "pdf1" ? "active1" : "notactive1"}
                    onClick={() => handleToggle1("pdf1")}
                  >
                    <Typography className="sub-headings ">
                      State PDFs
                    </Typography>
                  </Box>
                </Link>
              </li>
              {/* Stateimage */}
              <li>
                <Link
                  to="/master/Stateimage"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    className={
                      expanded1 === "Stateimage" ? "active1" : "notactive1"
                    }
                    onClick={() => handleToggle1("Stateimage")}
                  >
                    <Typography className="sub-headings ">
                      State Highlight
                    </Typography>
                  </Box>
                </Link>
              </li>

              {/*  */}
              <li>
                <Link
                  to="/master/Statestatus"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    className={expanded1 === "pdf2" ? "active1" : "notactive1"}
                    onClick={() => handleToggle1("pdf2")}
                  >
                    <Typography className="sub-headings ">
                      State Status
                    </Typography>
                  </Box>
                </Link>
              </li>
            </ul>
          )}
        </li>
        {/* 5th */}
        {role === "System Admin" && (
          <li>
            <Link
              to="/master/UserManagement"
              style={{ textDecoration: "none" }}
            >
              <div
                onClick={() => handleToggle("Administrator")}
                className="parent-li"
              >
                <Box
                  className={
                    expanded === "Administrator" ? "active" : "notactive"
                  }
                  sx={{ display: "flex", alignItems: "center", width: "100%" }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "5px" }}
                  >
                    <img src={profile} alt="Administrator" className="icons" />
                    <Typography className="headings">
                      User Management
                    </Typography>
                  </Box>
                </Box>
              </div>
            </Link>
          </li>
        )}
        {/* 6th */}
        <li>
          <Link to="/master/Audit" style={{ textDecoration: "none" }}>
            <div
              onClick={() => handleToggle("IntrodectoryVideo")}
              className="parent-li"
            >
              <Box
                className={
                  expanded === "IntrodectoryVideo" ? "active" : "notactive"
                }
                sx={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <img src={audit} alt="Category" className="icons" />
                  <Typography className="headings">Audit Trails</Typography>
                </Box>
              </Box>
            </div>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SidebarLayout;
